module.exports = __webpack_public_path__ + "img/8.a6073a81.png";